import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-snackbar-delete-draft',
	templateUrl: './snackbar-delete-draft.component.html',
	styleUrl: './snackbar-delete-draft.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class SnackbarDeleteDraftComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarDeleteDraftComponent>
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
